import React, { useState } from "react";
import "./style.css";
import { makeStyles } from "@material-ui/core/styles";
import { Dialog, DialogTitle, DialogContent, List, Button, Input, Grid } from "@material-ui/core";
import { BsXCircle } from "react-icons/bs";
import QRScanner from "../QRScanner";

const useStyles = makeStyles((theme) => ({
  dialogTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(2),
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  },
  closeIcon: {
    cursor: 'pointer',
  },
  dialogContent: {
    padding: theme.spacing(3),
    maxWidth: 600,
    width: '90vw',
    boxSizing: 'border-box',
    overflow: 'hidden',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  button: {
    marginTop: theme.spacing(2),
  },
}));

export interface AuthenticationDialogProps {
  open: boolean;
  onClose: () => void;
  setQrCodeText: any;
  authenticate: (qrcode: any) => void;
  setLoginSuccess: any;
}

export function AuthenticationDialog(props: AuthenticationDialogProps) {
  const classes = useStyles();
  const { onClose, open, setQrCodeText, authenticate, setLoginSuccess } = props;
  const [qrCodeData, setQrCodeData] = useState<any>();
  const [showScanner, setShowScanner] = useState(false);
  const [code, setCode] = useState("");
  
  const handleClose = () => {
    onClose();
  };

  const handleAuth = async (authCode: string) => {
    try {
      console.log({authCode})
      setShowScanner(false)
      setLoginSuccess(true);
      setQrCodeText( authCode );
      await authenticate(authCode);
    } catch (err) {
      // toast({
      //   variant: "destructive",
      //   title: "Authentication failed",
      //   description: (err as Error).message
      // });
      console.error(err);
    }
  };
  
  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    handleAuth(code);
  };

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      open={open}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        style: {
          margin: 12,
          width: '100%',
          maxWidth: 640,
          borderRadius: 12,
        }
      }}
    >
      <DialogTitle className={classes.dialogTitle}>
        User Authentication
        <BsXCircle onClick={handleClose} className={classes.closeIcon} />
      </DialogTitle>
      <List>
        <DialogContent className={classes.dialogContent}>
          {showScanner ? (
            <Grid container direction="column" spacing={2}>
              <Grid item>
                <QRScanner onScan={handleAuth} />
              </Grid>
              <Grid item>
                <Button
                  variant="outlined"
                  color="secondary"
                  fullWidth
                  onClick={() => setShowScanner(false)}
                >
                  Enter Code Manually
                </Button>
              </Grid>
            </Grid>
          ) : (
            <form onSubmit={onSubmit} className={classes.form}>
              <Input
                placeholder="Enter authentication code"
                value={code}
                onChange={(e) => setCode(e.target.value)}
                fullWidth
              />
              <Button type="submit" variant="contained" color="primary" fullWidth>
                Login
              </Button>
              <Button
                type="button"
                variant="outlined"
                color="secondary"
                fullWidth
                onClick={() => setShowScanner(true)}
              >
                Scan QR Code
              </Button>
            </form>
          )}

          {qrCodeData && (
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={authenticate}
              className={classes.button}
            >
              Authenticate
            </Button>
          )}
        </DialogContent>
      </List>
    </Dialog>
  );
}
